export const summarize = (arr: string[], maxLength: number, prefix: string = '') => {
  let text = '';
  const numberOfItems = arr.length;
  let numberofVisibleItems = 0;

  for (let i = 0; i < numberOfItems; i++) {
    const currentText = arr[i];
    const prefix = i < 1 ? '' : ', ';
    if (text.length + currentText.length + prefix.length <= maxLength) {
      text += prefix + currentText;
      numberofVisibleItems++;
    } else {
      break;
    }
  }

  if (numberofVisibleItems === numberOfItems && text.length + prefix.length + 2 < maxLength) {
    text = `${prefix}${prefix?.length > 0 ? ': ' : ' '}${text}`;
  }

  return { summarizedText: text, notVisibleItems: numberOfItems - numberofVisibleItems };
};

export const crop = (text: string, maxLength: number) => {
  if (text.length >= maxLength) {
    return text.substring(0, maxLength - 4) + '...';
  } else {
    return text;
  }
};

// Entfernt alle nicht-numerischen Zeichen aus einem String
export const sanitizeDigits = (value: string) => value.replace(/\D/g, '');

export const containsEmojis = (text: string) => {
  return /(\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/.test(text);
};
